<div class="tab-content" id="myTabContent">
  <div class="row g-2 mb-3">

    <div class="col-6 col-md-4 col-lg-2">
      <div class="stat-card h-100">
        <div class="icon-box bg-gold-subtle">
          <i class="bi bi-wallet2 text-gold"></i>
        </div>
        <div class="stat-content">
          <p class="stat-label">Total Investment</p>
          <h5 class="stat-value">{{toFixedDown(botProfit?.investment??0,2)}} <span class="unit">USDT</span></h5>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-4 col-lg-2">
      <div class="stat-card h-100">
        <div class="icon-box" [ngClass]="botProfit >= 0 ? 'bg-green-subtle' : 'bg-red-subtle'">
          <i class="bi"
            [ngClass]="botProfit >= 0 ? 'bi-graph-up-arrow text-success' : 'bi-graph-down-arrow text-danger'"></i>
        </div>
        <div class="stat-content">
          <p class="stat-label">Total Profit</p>
          <h5 class="stat-value" [ngClass]="botProfit?.profit >= 0 ? 'text-success' : 'text-danger'">
            {{ botProfit?.profit > 0 ? '+' : '' }}{{ toFixedDown(botProfit?.profit??0,2) }} <span
              class="unit">USDT</span>
          </h5>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-4 col-lg-2">
      <div class="stat-card h-100">
        <div class="icon-box bg-blue-subtle">
          <i class="bi bi-robot text-primary"></i>
        </div>
        <div class="stat-content">
          <p class="stat-label">Bots | Order</p>
          <h5 class="stat-value">{{ botProfit?.totalBots??0 }} | {{botProfit?.totalOrder??0}}</h5>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-6 col-lg-3">
      <button class="stat-card action-card w-100 h-100 text-start" (click)="downloadExcel('')" role="button"
        [disabled]="isDownloading">
        <div class="icon-box bg-info-subtle">
          <i class="bi bi-file-earmark-arrow-down text-info"></i>
        </div>
        <div class="stat-content">
          <p class="stat-label">Export Data</p>
          <h5 class="stat-value" style="font-size: 0.9rem; letter-spacing: 0.5px;">
            {{ isDownloading ? downloadProgress + '% ...' : 'Download CSV' }}
          </h5>
        </div>
      </button>
    </div>

    <div class="col-12 col-md-6 col-lg-3" *ngIf="activeBotCount > 0">
      <div class="d-flex gap-2 h-100">
        <button class="btn btn-danger flex-fill d-flex flex-column justify-content-center align-items-center shadow-sm"
          (click)="pauseBot('pause')" [disabled]="cancelLoader" style="border-radius: 12px;">
          <i class="bi bi-pause-circle-fill fs-4 mb-1"></i>
          <span style="font-size: 0.8rem; font-weight: 600;">Pause All</span>
        </button>

        <button class="btn btn-success flex-fill d-flex flex-column justify-content-center align-items-center shadow-sm"
          (click)="pauseBot('start')" [disabled]="cancelLoader" style="border-radius: 12px;">
          <i class="bi bi-play-circle-fill fs-4 mb-1"></i>
          <span style="font-size: 0.8rem; font-weight: 600;">Start All</span>
        </button>
      </div>
    </div>

  </div>
</div>

<div class="tab-pane fade show active" id="strategies-tab-pane" role="tabpanel" aria-labelledby="strategies-tab"
  tabindex="0">
  <div class="row align-items-center mt-2 g-2">

    <div class="col-lg-4 col-md-12">
      <ul class="nav nav-tabs bottab" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="activeBot-tab" type="button" data-bs-toggle="tab"
            (click)="selectTab('activeBot', 'bot')" data-bs-target="#activeBot" role="tab" aria-controls="activeBot"
            [attr.aria-selected]="selectedTab === 'activeBot'" [ngClass]="{ active: selectedTab === 'activeBot' }">
            Spot Bots ({{ activeBotCount }})
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="openPosition-tab" type="button" data-bs-toggle="tab"
            (click)="selectTab('openPosition', 'openPosition')" data-bs-target="#openPosition" role="tab"
            aria-controls="openPosition" [attr.aria-selected]="selectedTab === 'openPosition'"
            [ngClass]="{ active: selectedTab === 'openPosition' }">
            Open Position
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="stopedBot-tab" type="button" data-bs-toggle="tab"
            (click)="selectTab('stopedBot', 'bot')" data-bs-target="#stopedBot" role="tab" aria-controls="stopedBot"
            [attr.aria-selected]="selectedTab === 'stopedBot'" [ngClass]="{ active: selectedTab === 'stopedBot' }">
            Bot History
          </button>
        </li>
      </ul>
    </div>

    <div class="col-lg-8 col-md-12">
      <!--   <form (ngSubmit)="submitForm()">
        <div class="row align-items-center g-2 justify-content-end">

          <div class="col-lg-6 col-md-6 col-sm-12" *ngIf="activeBotCount < 2">
            <div class="row g-2">

              <div class="col-6">
                <div class="createbot_box">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="form-label grey" for="totalBots">Total Open Pairs</label>
                      <input id="totalBots" aria-label="totalBots" name="totalBots" class="form-control" type="text"
                        min="0.000001" (wheel)="onWheel($event)" inputmode="decimal" [ngModel]="formValue.totalBots"
                        pattern="[0-9]*[.]?[0-9]*" decimals (input)="handleTradeChange($event)" />
                    </div>
                    <span class="required" *ngIf="serverErrors?.totalBots">{{ serverErrors.totalBots }}</span>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="createbot_box">
                  <div class="inputgrp_box">
                    <div class="w-100 input-group">
                      <label class="form-label grey" for="investment">Investment</label>
                      <input id="investment" aria-label="investment" name="investment" class="form-control" type="text"
                        min="0.000001" (wheel)="onWheel($event)" inputmode="decimal" [ngModel]="formValue.investment"
                        pattern="[0-9]*[.]?[0-9]*" [appDecimalLimit]="pairData.secondFloatDigit" decimals
                        (input)="handleTradeChange($event)" />
                    </div>
                    <span class="required" *ngIf="serverErrors?.investment">{{ serverErrors.investment }}</span>

                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-3 col-sm-6" *ngIf="activeBotCount < 2">
            <button type="button" class="btn btn-success w-100" (click)="submitForm()"
              [disabled]="isSubmitting">Create</button>
          </div>
        </div>
      </form> -->

      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#createBotModal">
          <i class="bi bi-plus-lg me-1"></i> Create New Bot
        </button>
      </div>
    </div>
  </div>


  <!-- Bot mode -->
  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade" [ngClass]="{
          show: selectedTab === 'activeBot',
          active: selectedTab === 'activeBot'
        }" id="activeBot" role="tabpanel" aria-labelledby="activeBot-tab">
      <div class="bot-history-filter">
        <!-- <p>Sum, Current value $ {{toFixed(totCurrent,2)}}</p> -->
      </div>
      <!-- open bot -->
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Total Open Pairs</th>
              <!-- <th>PNL In %</th> -->
              <th>PNL</th>
              <th>TXNS/Time</th>
              <th>Investment</th>
              <th>Status</th>
              <th *ngIf="environment.production == false">Action</th>
            </tr>
          </thead>
          <tbody *ngIf="activeBotCount > 0; else noActiveBot">
            <tr *ngFor="let item of activeBotData" (click)="selectBot(item)" style="cursor: pointer">
              <td>
                <span class="botType">{{ item.totalBots }}</span>
                <span class="botAction" *ngIf="item.isManual">{{"Manual"}}</span>
              </td>
              <!-- //redText -->
              <!-- <td class="{{ item.pl > 0 ? 'greenTxt' : 'redText' }}">
                  {{ toFixed(item.pl, 2) }}%
                </td> -->
              <td class="{{ item.pnlval > 0 ? 'greenTxt' : 'redText' }}">
                {{ item.pnlval }} USDT
              </td>
              <td>{{ item.txnDate }}</td>
              <td>{{truncateDecimals(item?.totalInvestment?? item.investment,4) }}</td>
              <td class="{{ item.status =='running' ? 'greenTxt' : 'redText' }}">{{firstCapital(item.status) }}</td>
              <th>
                <span class="botAction" (click)="onModelOpen(item)" data-bs-toggle="modal"
                  data-bs-target="#ohis_modal">View</span>
                <button class="botType" (click)="cancel('bot','botClose',item)" [disabled]="cancelLoader">
                  Close Bot
                </button>
                &nbsp;
                <button class="btn btn-sm btn-outline-primary border-0 me-2"
                  (click)="$event.stopPropagation(); downloadExcel(item._id)" title="Download Report"
                  [disabled]="isDownloading">
                  <i class="bi bi-download"></i>
                </button>
              </th>
            </tr>
          </tbody>
        </table>
        <div class="tab-pane">
          <nav class="primary_pagination" *ngIf="filter.totalPages > 1">
            <ul class="pagination">
              <li class="page-item" [ngClass]="{ disabled: filter.page == 1 }">
                <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('bot')">
                  <span aria-hidden="true">&laquo;</span>
                </span>
              </li>
              <li class="page-item" *ngFor="let item of getDisplayedPages">
                <a class="page-link" [ngClass]="{ active: item == filter.page }" href="javascript:void(0)"
                  (click)="goToSelectedPage(item, 'bot')">{{ item }}</a>
              </li>
              <li class="page-item" [ngClass]="{ disabled: filter.totalPages == filter.page }">
                <span class="page-link cursor-pointer" (click)="nextPage('bot')" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </span>
              </li>
            </ul>
          </nav>
        </div>
        <ng-template #noActiveBot>
          <tbody>
            <tr>
              <td colspan="9" style="border-color: transparent">
                <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                  <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                  <p>No Records Found!</p>
                </div>
                <ng-template #login>
                  <div class="text-center mt-4 mb-4">
                    <!-- <p>
                                              <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                  href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                          </p> -->
                    <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                    <p>
                      <a class="blue_txt no-underline" href="signin">Login</a>
                      or
                      <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                      Now to trade
                    </p>
                  </div>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </ng-template>
      </div>
    </div>

    <!-- open possition history -->
    <div class="tab-pane fade" [ngClass]="{
          show: selectedTab === 'openPosition',
          active: selectedTab === 'openPosition'
        }" id="openPosition" role="tabpanel" aria-labelledby="openPosition-tab">
      <div class="bot-history-filter">
        <!-- <p>Sum, Current value $ {{toFixed(totCurrent,2)}}</p> -->
      </div>
      <div class="table-responsive">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>No</th>
                <th>Date & Time</th>
                <th>Pair</th>
                <th>Buy Price</th>
                <!-- <th>Open Amount</th> -->
                <th>Sell Price</th>
                <th>Market Price</th>
                <th>Amount</th>
                <th>Total(USDT)</th>
                <th>Estimate Profit</th>
                <th>View</th>
              </tr>
            </thead>

            <tbody *ngIf="botPositionHistory.length > 0; else noOpenPosData">
              <ng-container *ngFor="let group of botPositionHistory">

                <!-- Buy Row -->
                <tr (click)="selectBot(group)" style="cursor: pointer">
                  <td>{{ group.postRound }}</td>
                  <td>
                    {{ dateTimeFormat(group.createdAt) }}
                  </td>
                  <td (click)="loadChart(group.symbol)">
                    <span class="botType">{{ group.symbol }}</span>
                    <span class="botAction" *ngIf="group.buyOrderId.palcedBy=='manual'">{{"Manual"}}</span>
                  </td>
                  <td>
                    {{
                    toFixedDown(
                    group?.openPrice,
                    group.buyOrderId?.secondFloatDigit
                    )
                    }}
                  </td>
                  <!-- <td>
                      {{
                      toFixedDown(
                      group.buyOrderId?.status === "completed"
                      ? group.buyOrderId?.fillQuantity
                      : group.buyOrderId?.quantity,
                      group.buyOrderId?.firstFloatDigit
                      )
                      }}
                    </td> -->
                  <td>
                    {{
                    group?.sellOrderId?.price ? toFixedDown( group?.sellOrderId?.price,
                    group?.sellOrderId?.secondFloatDigit
                    ):"-"
                    }}
                  </td>
                  <td>
                    {{
                    toFixedDown( group?.sellOrderId?.markPrice,
                    group?.sellOrderId?.secondFloatDigit
                    )
                    }}
                  </td>

                  <td>
                    {{
                    toFixedDown(group?.sellOrderId?.quantity,
                    group?.sellOrderId?.firstFloatDigit
                    )
                    }}
                  </td>
                  <td>
                    {{
                    toFixedDown(
                    group?.orderValue,
                    group?.buyOrderId?.secondFloatDigit
                    )
                    }}
                  </td>
                  <td class="{{ parseFloat(group.esProfit) > 0 ? 'greenTxt' : 'redText' }}">
                    {{
                    group.esProfit||'---'
                    }}
                    <span *ngIf="group?.profitPercent"
                      [class]="parseFloat(group.esProfit) > 0 ? 'greenTxt' : 'redText'">({{parseFloat(group?.profitPercent)
                      }}%)</span>
                  </td>
                  <td *ngIf="group.status == 'open'">
                    <!-- <button class="botAction" (click)="cancel('position','keep',group)" [disabled]="cancelLoader">Keep
                        Cancel</button> -->
                    <button class="botAction" *ngIf="group?.sellOrderId?.status == 'pending'"
                      (click)="cancelAndWait(group?.sellOrderId?._id)" [disabled]="cancelLoader">Keep
                      Cancel and Wait</button>
                    <button class="botType" (click)="cancel('position','market',group)" [disabled]="cancelLoader">Sell
                      At Market</button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div class="tab-pane">
            <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
              <ul class="pagination">
                <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                  <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                    <span aria-hidden="true">&laquo;</span>
                  </span>
                </li>
                <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                  <a class="page-link" [ngClass]="{ active: item == orderFilter.page }" href="javascript:void(0)"
                    (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                </li>
                <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                  <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </span>
                </li>
              </ul>
            </nav>
          </div>
          <ng-template #noOpenPosData>
            <tbody>
              <tr>
                <td colspan="9" style="border-color: transparent">
                  <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                    <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                    <p>No Records Found!</p>
                  </div>
                  <ng-template #login>
                    <div class="text-center mt-4 mb-4">
                      <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                      <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                      <p>
                        <a class="blue_txt no-underline" href="signin">Login</a>
                        or
                        <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                        Now to trade
                      </p>
                    </div>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="tab-pane fade" [ngClass]="{
          show: selectedTab === 'stopedBot',
          active: selectedTab === 'stopedBot'
        }" id="stopedBot" role="tabpanel" aria-labelledby="stopedBot-tab">
      <!-- <div class="noActiveBots">
          <img src="assets/images/noactivebots.svg" class="img-fluid" alt="icon" />
          <p>You don’t have active bots</p>
          <button class="btn startButton">Start NewBot</button>
        </div> -->
      <div class="bot-history-filter">
        <div class="bh-filter-left">
          <!-- <p>Sum, Current value $ {{toFixed(sumProfitHis?.curVal,2)}}</p>
                        <p>
                            Sum, bot profit $ {{sumProfitHis?.sumpnlval}}
                            <span *ngIf="sumProfitHis.sumpnlval < 0" class="redText">{{sumProfitHis?.pnlVal}}%</span>
                            <span *ngIf="sumProfitHis.sumpnlval > 0" class="greenText">{{sumProfitHis?.pnlVal}}%</span>
                        </p>
                        <p>Sum, Investment $ {{sumProfitHis?.inv}}</p> -->
        </div>
        <!-- <div class="bh-filter-right">
                      <mat-form-field appearance="fill">
                          <input matInput [matDatepicker]="picker" />
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                      <button class="continue">
                          <img src="../../../assets/images/date_picker.png" alt="date" title="date" />
                      </button>
                      <button class="startButton">Download CSV</button>
                  </div> -->
      </div>
      <div class="table-responsive">
        <!-- closed bot -->
        <table class="table table-bordered">
          <thead>
            <tr>
              <!-- <th>Exchange</th> -->
              <th>Total Open Pairs</th>
              <!-- <th>Fee (USDT)</th> -->
              <!-- <th>PNL In %</th> -->
              <th>PNL</th>
              <th>TXNS/Time</th>
              <th>Investment</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody *ngIf="botHistory.length > 0; else noBotClosed">
            <tr *ngFor="let item of botHistory" (click)="selectBot(item)" style="cursor: pointer">
              <!-- <td>
                                  <img src="assets/images/binance.svg" alt="Binance" title="Binance" />
                                  Binance
                              </td> -->
              <td>
                <span class="botType">{{ item.totalBots }}</span>
                <span class="botAction" *ngIf="item.isManual">{{"Manual"}}</span>
              </td>
              <!-- <td>{{ toFixedDown(item.fee, 8) }}</td> -->
              <!-- //redText -->
              <!-- <td class="{{ parseFloat(item.pl) > 0 ? 'greenTxt' : 'redText' }}">
                  {{ item.pl }}%
                </td> -->
              <td class="{{
                    parseFloat(item.pnlval) > 0 ? 'greenTxt' : 'redText'
                  }}">
                {{ item.pnlval }}
                <span class="valueInPrice">{{ item.secondCurrency }}</span>
              </td>
              <td>{{ item.creAt }}</td>
              <td>{{ truncateDecimals(item?.totalInvestment?? item.investment,4) }}</td>
              <td>
                <span class="greenTxt">Closed</span> {{ item.closeDate }}
              </td>
              <td>
                <span class="botAction" (click)="onModelOpen(item)" data-bs-toggle="modal"
                  data-bs-target="#ohis_modal">View</span>
                &nbsp;
                <button class="btn btn-sm btn-outline-primary border-0 me-2"
                  (click)="$event.stopPropagation(); downloadExcel(item._id)" title="Download Report"
                  [disabled]="isDownloading">
                  <i class="bi bi-download"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tab-pane">
          <nav class="primary_pagination" *ngIf="filter.totalPages > 1">
            <ul class="pagination">
              <li class="page-item" [ngClass]="{ disabled: filter.page == 1 }">
                <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('bot')">
                  <span aria-hidden="true">&laquo;</span>
                </span>
              </li>
              <li class="page-item" *ngFor="let item of getDisplayedPages">
                <a class="page-link" [ngClass]="{ active: item == filter.page }" href="javascript:void(0)"
                  (click)="goToSelectedPage(item, 'bot')">{{ item }}</a>
              </li>
              <li class="page-item" [ngClass]="{ disabled: filter.totalPages == filter.page }">
                <span class="page-link cursor-pointer" (click)="nextPage('bot')" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </span>
              </li>
            </ul>
          </nav>
        </div>
        <ng-template #noBotClosed>
          <tbody>
            <tr>
              <td colspan="9" style="border-color: transparent">
                <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                  <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                  <p>No Records Found!</p>
                </div>
                <ng-template #login>
                  <div class="text-center mt-4 mb-4">
                    <!-- <p>
                                              <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                  href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                          </p> -->
                    <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                    <p>
                      <a class="blue_txt no-underline" href="signin">Login</a>
                      or
                      <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                      Now to trade
                    </p>
                  </div>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Order history Modal -->
  <div class="modal fade primary_modal detail_model modal-xl" id="ohis_modal" tabindex="-1"
    aria-labelledby="ohis_modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="ohis_modalLabel">
            Bot Orders History
          </h1>
          <div class="d-flex align-items-start">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              (click)="onModelClose()"></button>
          </div>
        </div>
        <ul class="nav nav-tabs bottab mt-2" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="positionHistory-tab" type="button" data-bs-toggle="tab"
              data-bs-target="#positionHistory" role="tab" aria-controls="positionHistory"
              [attr.aria-selected]="selectedOrderTab === 'positionHistory'"
              [ngClass]="{ active: selectedOrderTab === 'positionHistory' }"
              (click)="selectTab('positionHistory', 'order')">
              Position History
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="closedOrder-tab" type="button" data-bs-toggle="tab"
              data-bs-target="#closedOrder" role="tab" aria-controls="closedOrder"
              [attr.aria-selected]="selectedTab === 'closedOrder'"
              [ngClass]="{ active: selectedOrderTab === 'closedOrder' }" (click)="selectTab('closedOrder', 'order')">
              Closed Orders
            </button>
          </li>
          <li *ngIf="openModelBotDetails &&
                openModelBotDetails.status == 'running'
              " class="nav-item" role="presentation">
            <button class="nav-link" id="openOrder-tab" type="button" data-bs-toggle="tab" data-bs-target="#openOrder"
              role="tab" aria-controls="openOrder" [attr.aria-selected]="selectedOrderTab === 'openOrder'"
              [ngClass]="{ active: selectedOrderTab === 'openOrder' }" (click)="selectTab('openOrder', 'order')">
              Open orders
            </button>
          </li>
        </ul>
        <div class="modal-body" style="max-height: 600px; overflow-y: auto">
          <!-- Position details in model -->
          <!-- <div class="d-flex flex-column flex-md-row justify-content-end align-items-end mb-3 gap-3">
              <div class="inputgrp_box">
                <div class="input-group">
                  <label class="grey">Investment</label
                  ><input
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    name=""
                    type="text"
                    class="form-control ng-pristine ng-valid ng-touched mb-0"
                  />
                </div>
              </div>
              <div class="inputgrp_box ">
                <div class="input-group">
                  <label class="grey">Total Profit</label
                  ><input
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    name=""
                    type="text"
                    class="form-control ng-pristine ng-valid ng-touched mb-0"
                  />
                </div>
              </div>
            </div> -->
          <div class="tab-content mt-3" id="myTabContent">
            <div class="tab-pane fade" [ngClass]="{
                  show: selectedOrderTab === 'positionHistory',
                  active: selectedOrderTab === 'positionHistory'
                }" id="positionHistory" role="tabpanel" aria-labelledby="positionHistory-tab">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th colspan="2">No</th>
                      <th>Date & Time</th>
                      <th colspan="2">Pair</th>
                      <th>Side</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th>Total ({{ pairData.secondCurrencySymbol }})</th>
                      <th>Status</th>
                      <th>Fee</th>
                      <th *ngIf="openModelBotDetails">Profit</th>
                      <!-- <th *ngIf="openModelBotDetails && openModelBotDetails.status == 'running'">View</th> -->
                    </tr>
                  </thead>

                  <tbody *ngIf="botPositionHistory.length > 0; else noOpenPosData">
                    <ng-container *ngFor="let group of botPositionHistory">
                      <!-- Group Header -->
                      <!-- <tr>
                                                    <td colspan="9">
                                                        <div
                                                            class="group-header d-flex justify-content-between align-items-center p-2">
                                                            <div class="group-id  fw-bold">#{{ group.postRound }}</div>
                                                            <div class="profit fw-bold"
                                                                [ngClass]="{ 'text-success': group.profit >= 0, 'text-danger': group.profit < 0 }">
                                                                {{ group.profit }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> -->
                      <!-- <tr>
                          <td colspan="9">
                            <div class="group-header d-flex justify-content-between align-items-center p-2">
                              <div class="group-id  fw-bold">{{ group.symbol }}</div>
                              <div class="profit fw-bold"
                                [ngClass]="{ 'text-success': group.profit >= 0, 'text-danger': group.profit < 0 }">
                                {{ toFixedDown(group.profit,4) }} USDT
                              </div>
                            </div>
                          </td>
                        </tr> -->

                      <!-- Sell Row -->
                      <tr *ngIf="group.sellOrderId">
                        <td colspan="2">
                          <div class="group-id fw-bold">
                            {{ group.postRound }}
                          </div>
                        </td>
                        <td>
                          {{ dateTimeFormat(group?.sellOrderId?.createdAt) }}
                        </td>
                        <td colspan="2">
                          <div class="group-id fw-bold" class="text-info">
                            {{ group.symbol }}
                          </div>
                        </td>
                        <td><span class="text-danger">Sell</span></td>
                        <td>
                          {{
                          toFixedDown(
                          group?.sellOrderId?.status === "completed"
                          ? group?.sellOrderId?.execPrice
                          : group?.sellOrderId?.price,
                          group?.sellOrderId?.secondFloatDigit
                          )
                          }}
                        </td>
                        <td>
                          {{
                          toFixedDown(
                          group?.sellOrderId?.status === "completed"
                          ? group?.sellOrderId?.fillQuantity
                          : group?.sellOrderId?.quantity,
                          group?.sellOrderId?.firstFloatDigit
                          )
                          }}
                        </td>
                        <td>
                          {{
                          toFixedDown(
                          (
                          group?.sellOrderId?.status === "completed"
                          ? group?.sellOrderId?.execPrice
                          : group?.sellOrderId?.price
                          ) *
                          (
                          group?.sellOrderId?.status === "completed"
                          ? group?.sellOrderId?.fillQuantity
                          : group?.sellOrderId?.quantity
                          ),
                          group?.sellOrderId?.secondFloatDigit
                          )
                          }}
                        </td>

                        <!-- <td>
                          {{
                          group?.sellOrderId?.status === "completed"
                          ? toFixedDown(
                          group?.sellOrderId?.fillOrderValue,
                          group?.sellOrderId?.secondFloatDigit
                          )
                          : "-"
                          }}
                        </td> -->
                        <td [ngClass]="
                              group?.sellOrderId?.status === 'completed'
                                ? 'green_txt'
                                : 'red_txt'
                            ">
                          {{ firstCapital(group?.sellOrderId?.status) }}
                        </td>
                        <td>
                          {{
                          group?.sellOrderId?.status === "completed"
                          ? toFixedDown(group?.closeFee, 8)
                          : "-"
                          }}
                        </td>
                        <td colspan="2" *ngIf="openModelBotDetails">
                          <div class="profit fw-bold" [ngClass]="{
                                'text-success': group.profit >= 0,
                                'text-danger': group.profit < 0
                              }">
                            {{ toFixedDown(group.profit, 8) }}
                          </div>
                        </td>
                        <!-- <td colspan="2" *ngIf="openModelBotDetails && openModelBotDetails.status == 'running'">
                            <div>
                              {{ toFixedDown(group.profit, 8) }}
                            </div>
                          </td> -->
                      </tr>

                      <!-- Sell Missing Message -->
                      <tr *ngIf="isEmpty(group.sellOrderId)">
                        <td colspan="2">
                          <div class="group-id fw-bold">
                            #{{ group.postRound }}
                          </div>
                        </td>
                        <td *ngIf="
                              group.buyOrderId &&
                              group.buyOrderId?.status != 'cancelled'
                            ">
                          Your sell order is still waiting to be completed.
                        </td>
                      </tr>
                      <!-- Buy Row -->
                      <tr *ngIf="group.buyOrderId">
                        <td colspan="2"></td>
                        <td>
                          {{ dateTimeFormat(group.buyOrderId?.createdAt) }}
                        </td>
                        <td colspan="2"></td>
                        <td><span class="text-success">Buy</span></td>
                        <td>
                          {{
                          toFixedDown(
                          group?.openPrice,
                          group?.buyOrderId?.secondFloatDigit
                          )
                          }}
                        </td>
                        <td>
                          {{
                          toFixedDown(
                          group?.quantity,
                          group?.buyOrderId?.firstFloatDigit
                          )
                          }}
                        </td>

                        <td>
                          {{
                          group?.buyOrderId?.status === "completed"
                          ? toFixedDown(
                          group?.orderValue,
                          group?.buyOrderId?.secondFloatDigit
                          )
                          : "-"
                          }}
                        </td>
                        <td [ngClass]="
                              group.buyOrderId?.status === 'completed'
                                ? 'green_txt'
                                : 'red_txt'
                            ">
                          {{ firstCapital(group.buyOrderId?.status) }}
                        </td>
                        <td>
                          {{
                          group.buyOrderId?.status === "completed"
                          ? toFixedDown(group.openFee, 8)
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr *ngIf="isEmpty(group.buyOrderId)">
                        <td colspan="2">
                          <div class="group-id fw-bold">
                            #{{ group.postRound }}
                          </div>
                        </td>
                        <td *ngIf="
                              group?.sellOrderId &&
                              group?.sellOrderId?.status != 'cancelled'
                            ">
                          Your buy order is still waiting to be completed..
                        </td>
                      </tr>
                      <hr style="
                            border: 0;
                            height: 1px;
                            background: transparent;
                            margin: 1rem 0;
                          " />
                    </ng-container>
                  </tbody>
                </table>
                <div class="tab-pane">
                  <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
                    <ul class="pagination">
                      <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                        <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                          <span aria-hidden="true">&laquo;</span>
                        </span>
                      </li>
                      <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                        <a class="page-link" [ngClass]="{ active: item == orderFilter.page }" href="javascript:void(0)"
                          (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                      </li>
                      <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                        <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                        </span>
                      </li>
                    </ul>
                  </nav>
                </div>
                <ng-template #noOpenPosData>
                  <tbody>
                    <tr>
                      <td colspan="9" style="border-color: transparent">
                        <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                          <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                          <p>No Records Found!</p>
                        </div>
                        <ng-template #login>
                          <div class="text-center mt-4 mb-4">
                            <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                            <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                            <p>
                              <a class="blue_txt no-underline" href="signin">Login</a>
                              or
                              <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                              Now to trade
                            </p>
                          </div>
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </div>
            </div>

            <div class="tab-pane fade" [ngClass]="{
                  show: selectedOrderTab === 'closedOrder',
                  active: selectedOrderTab === 'closedOrder'
                }" id="closedOrder" role="tabpanel" aria-labelledby="closedOrder-tab">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Date & Time Time</th>
                      <th>Pair</th>
                      <th>Side</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th>Total (USDT)</th>
                      <th>Fee</th>
                      <th>Status</th>

                      <!-- <th>Profit (USDT)</th> -->
                    </tr>
                  </thead>
                  <tbody *ngIf="orderList.length > 0; else noClosedOrder">
                    <tr *ngFor="let row of orderList">
                      <td>{{ dateTimeFormat(row.createdAt) }}</td>
                      <td>{{ row.symbol }}</td>
                      <td *ngIf="row.side == 'sell'">
                        <span class="red_txt">{{
                          firstCapital(row.side)
                          }}</span>
                      </td>
                      <td *ngIf="row.side == 'buy'">
                        <span class="green_txt">{{
                          firstCapital(row.side)
                          }}</span>
                      </td>
                      <td>
                        {{ toFixedDown(row.execPrice, row.secondFloatDigit) }}
                      </td>
                      <td>
                        {{
                        toFixedDown(row.fillQuantity, row.firstFloatDigit)
                        }}
                      </td>
                      <td>
                        {{
                        toFixed(row.fillOrderValue, row.secondFloatDigit)
                        }}
                      </td>
                      <td>{{ toFixed(row.fee, 8) }}</td>
                      <td [ngClass]="
                            row.status === 'completed' ? 'green_txt' : 'red_txt'
                          ">
                        {{ firstCapital(row.status) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="tab-pane">
                  <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
                    <ul class="pagination">
                      <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                        <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                          <span aria-hidden="true">&laquo;</span>
                        </span>
                      </li>
                      <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                        <a class="page-link" [ngClass]="{ active: item == orderFilter.page }" href="javascript:void(0)"
                          (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                      </li>
                      <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                        <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                        </span>
                      </li>
                    </ul>
                  </nav>
                </div>
                <ng-template #noClosedOrder>
                  <tbody>
                    <tr>
                      <td colspan="9" style="border-color: transparent">
                        <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                          <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                          <p>No Records Found!</p>
                        </div>
                        <ng-template #login>
                          <div class="text-center mt-4 mb-4">
                            <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                            <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                            <p>
                              <a class="blue_txt no-underline" href="signin">Login</a>
                              or
                              <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                              Now to trade
                            </p>
                          </div>
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </div>
              <!-- <div class="bh-filter-right">
                          <button class="startButton mt-3">Download CSV</button>
                        </div> -->
            </div>

            <!-- open order details -->
            <div class="tab-pane fade" [ngClass]="{
                  show: selectedOrderTab === 'openOrder',
                  active: selectedOrderTab === 'openOrder'
                }" id="openOrder" role="tabpanel" aria-labelledby="openOrder-tab">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Date & Time Time</th>
                      <th>Pair</th>
                      <th>Side</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th>Total ({{ pairData.secondCurrencySymbol }})</th>
                      <th>Order Status</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="openOrderList.length > 0; else noOpenOrderData">
                    <tr *ngFor="let row of openOrderList">
                      <td>{{ dateTimeFormat(row.createdAt) }}</td>
                      <td>{{ row.symbol }}</td>
                      <td *ngIf="row.side === 'buy'">
                        <span class="green_txt">{{
                          firstCapital(row.side)
                          }}</span>
                      </td>
                      <td *ngIf="row.side === 'sell'">
                        <span class="red_txt">{{
                          firstCapital(row.side)
                          }}</span>
                      </td>
                      <td>
                        {{ toFixedDown(row.price, row.secondFloatDigit) }}
                      </td>
                      <td>
                        {{ toFixedDown(row.quantity, row.firstFloatDigit) }}
                      </td>
                      <td>
                        {{
                        toFixedDown(
                        toFixedDown(row.price, row.secondFloatDigit) *
                        toFixedDown(row.quantity, row.firstFloatDigit),
                        row.firstFloatDigit + row.secondFloatDigit
                        )
                        }}
                      </td>
                      <td *ngIf="row.status == 'Cancelled'">
                        Manual Cancelled from exchange
                      </td>
                      <td *ngIf="row.status != 'Cancelled'" [ngClass]="
                            row.status === 'completed' ? 'green_txt' : 'red_txt'
                          ">
                        {{ firstCapital(row.status) }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="tab-pane">
                  <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
                    <ul class="pagination">
                      <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                        <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                          <span aria-hidden="true">&laquo;</span>
                        </span>
                      </li>
                      <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                        <a class="page-link" [ngClass]="{ active: item == orderFilter.page }" href="javascript:void(0)"
                          (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                      </li>
                      <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                        <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                        </span>
                      </li>
                    </ul>
                  </nav>
                </div>
                <ng-template #noOpenOrderData>
                  <tbody>
                    <tr>
                      <td colspan="9" style="border-color: transparent">
                        <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                          <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                          <p>No Records Found!</p>
                        </div>
                        <ng-template #login>
                          <div class="text-center mt-4 mb-4">
                            <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                            <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                            <p>
                              <a class="blue_txt no-underline" href="signin">Login</a>
                              or
                              <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                              Now to trade
                            </p>
                          </div>
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="modal fade primary_modal" id="createBotModal" tabindex="-1" aria-labelledby="createBotLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="createBotLabel">Create Bot Strategy</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <form (ngSubmit)="submitForm()">
            <div class="row g-3">

              <div class="col-4">
                <div class="createbot_box">
                  <div class="inputgrp_box">
                    <label class="form-label grey" for="modalTotalBots">Total Pairs</label>
                    <div class="input-group">
                      <input id="modalTotalBots" name="totalBots" class="form-control" type="number"
                        placeholder="e.g. 5" [(ngModel)]="formValue.totalBots" />
                    </div>
                    <div class="text-danger small mt-1" *ngIf="serverErrors?.totalBots">
                      {{ serverErrors.totalBots }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="createbot_box">
                  <div class="inputgrp_box" *ngIf="!formValue.isManual">
                    <label class="form-label grey" for="modalProfit">Profit %</label>
                    <div class="input-group">
                      <input id="modalProfit" name="profitPercentage" class="form-control" type="number"
                        placeholder="e.g. 1" [(ngModel)]="formValue.profitPercentage" (wheel)="onWheel($event)"
                        inputmode="decimal" pattern="[0-9]*[.]?[0-9]*" />
                      <span class="input-group-text px-1">%</span>
                    </div>
                    <div class="text-danger small mt-1" *ngIf="serverErrors?.profitPercentage">
                      {{ serverErrors.profitPercentage }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="createbot_box h-100 d-flex align-items-center ps-3">
                  <!-- <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="manualBotCheck" name="isManual"
                      [(ngModel)]="formValue.isManual">
                    <label class="form-check-label grey fw-bold" for="manualBotCheck">
                      Manual Bot
                    </label>
                  </div> -->
                </div>
              </div>

              <div class="col-12">
                <div class="createbot_box">
                  <div class="inputgrp_box">
                    <label class="form-label grey small">Total Investment</label>
                    <div class="input-group">
                      <input name="firstOrder" class="form-control form-control-sm" type="number"
                        [(ngModel)]="formValue.investment" placeholder="0" (wheel)="onWheel($event)" inputmode="decimal"
                        pattern="[0-9]*[.]?[0-9]*">
                    </div>
                    <div class="text-danger small mt-1" *ngIf="serverErrors?.investment">
                      {{ serverErrors.investment }}
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="modal-footer border-0 mt-3">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="cancelBtn">Cancel</button>
              <button type="button" class="btn btn-success" (click)="submitForm()" [disabled]="isSubmitting">
                <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
                {{ isSubmitting ? 'Creating...' : 'Create Bot' }}
              </button>
            </div>

          </form>
        </div>

      </div>
    </div>
  </div>


</div>